import SkeletonBlock from '@sharedComponents/SkeletonBlock';
import Typography from '@sharedComponents/Typography';
import PropTypes from 'prop-types';

import * as style from './style.module.css';

/**
 * Skeleton of a line of text. It renders the same `Typography` as the text it stands for (pass the same
 * `fontSize`, `fontWeight`, `seo`, `className`...), so the line box has the same height as the real text. The bar is
 * sized in `em`, so it follows the font size, and is centred on the line without changing its height. Hidden from
 * assistive technologies: a heading skeleton must not be announced as an empty heading.
 * `width`: width of the bar, carried by a wrapper: in a flex row, a line holding a single space would shrink to nothing.
 */
const SkeletonText = ({ width = '100%', className = '', seo, ...props }) => (
    <div className={style.wrapper} style={{ width }} aria-hidden="true">
        <Typography {...props} seo={seo} div={!seo} className={`${style.line} ${className}`}>
            {'\u00A0'}
            <SkeletonBlock width="100%" height="1em" className={style.bar} />
        </Typography>
    </div>
);

SkeletonText.propTypes = {
    width: PropTypes.string,
    className: PropTypes.string,
    seo: PropTypes.number,
};

export default SkeletonText;
